//swift day
export const RESET_SWIFT_DAY = "RESET_SWIFT_DAY";
export const SET_PROCESSING_SWIFT_DAY = "SET_PROCESSING_SWIFT_DAY";
export const STOP_PROCESSING_SWIFT_DAY = "STOP_PROCESSING_SWIFT_DAY";
export const LOAD_CORZAP_MESSAGES = "LOAD_CORZAP_MESSAGES";
export const GET_CORZAP_MESSAGES = "GET_CORZAP_MESSAGES";
export const SET_CURRENT_BIC = "SET_CURRENT_BIC";
export const SET_CURRENT_MESSAGE_STATUS = "SET_CURRENT_MESSAGE_STATUS";
export const SET_CURRENT_TYPE = "SET_CURRENT_TYPE";
export const SET_CURRENT_MESSAGE = "SET_CURRENT_MESSAGE";
export const FILTER_CURRENT_TYPE_MESSAGES = "FILTER_CURRENT_TYPE_MESSAGES";
export const SENDING_MAIL = "SENDING_MAIL";
export const SET_BANK_LOGO_URL = "SET_BANK_LOGO_URL_SDAY";

// SWIFT MESSAGES
export const SEARCH_SWIFT_MESSAGES = "SEARCH_SWIFT_MESSAGES";
export const RESET_SWIFT_MESSAGES = "RESET_SWIFT_MESSAGES";
export const SET_PROCESSING_SWIFT_MESSAGES = "SET_PROCESSING_SWIFT_MESSAGES";
export const STOP_PROCESSING_SWIFT_MESSAGES = "STOP_PROCESSING_SWIFT_MESSAGES";
export const LOAD_COUNTRIES = "LOAD_COUNTRIES";
export const LOAD_CURRENCIES = "LOAD_CURRENCIES";
export const LOAD_MESSAGE_TYPES = "LOAD_MESSAGE_TYPES";
export const LOAD_FIELD_NAMES = "LOAD_FIELD_NAMES";
